// extracted by mini-css-extract-plugin
export default {"container":"NoResults_container__ZVpXZ","title":"NoResults_title__994h7","subTitle":"NoResults_subTitle__RMNI1"};